const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "대상년도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
          afterFix: "년",
          labelHiddenResolution: "xl",
        },
      },
      {
        component: "search-year-half",
        label: "반기",
        value: "half",
        query: { y_h: "half" },
        options: {
          default: new Date().getMonth() + 1 < 7 ? "상반기" : "하반기",
          labelHiddenResolution: "xl",
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "대상년도", "반기", "작성일", "첨부파일"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    const year = search.year;
    conditions.push({ key: "header.year", operator: "=", value: `${year}` });

    // 상반기 / 하반기
    if (search.half && search.half.length > 0) {
      conditions.push({ key: "header.half", operator: "=", value: search.half });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "대상년도",
        key: "header.year",
      },
      {
        name: "반기",
        key: "header.half",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "소속1",
        key: "body.stdInfo.section",
      },
      {
        name: "소속2",
        key: "body.stdInfo.department",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
      {
        name: "작성일",
        key: "created_at",
      },
      {
        name: "첨부파일",
        key: "body.fileList[%]",
      },
    ];
  },

  getCol: (index, value, func) => {
    try {
      if (func._getCol) {
        if (index === 7) {
          return {
            type: "file",
            files: func.getContent(value).fileList,
          };
        } else {
          return func._getCol(index, value, func);
        }
      }
    } catch (e) {}
    return "";
  },
};
export default list;
